import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CommonModule } from '@angular/common'
import { SerieProposalItemModule } from './serie-proposal-item/serie-proposal-item.module'
import { SerieProposalRoutingModule } from './serie-proposal-routing.module'
import { SerieProposalEffects } from './serie-proposal.effects'
import * as fromSerieProposal from './serie-proposal.reducer'
import { SerieProposalSerializer } from './serie-proposal.serializer'
import { SerieProposalService } from './serie-proposal.service'

@NgModule({
  imports: [
    CommonModule,
    SerieProposalRoutingModule,
    SharedModule,
    StoreModule.forFeature(
      fromSerieProposal.FEATURE_NAME,
      fromSerieProposal.serieProposalReducer
    ),
    EffectsModule.forFeature([SerieProposalEffects]),
    SerieProposalItemModule
  ],
  declarations: [],
  exports: [],
  providers: [
    SerieProposalService,
    {
      provide: SerieProposalSerializer,
      useClass: SerieProposalSerializer
    }
  ]
})
export class SerieProposalModule {}
